/**
*
* Asynchronously loads the component for SuccessfulRequest
*
*/
import React from 'react';
import { lazyLoad } from 'common/loadable';
import { PageLoading } from 'app/components/common/pageLoading';

export const SuccessfulRequest = lazyLoad(() => import('./index'), module => module.SuccessfulRequest, {fallback: <PageLoading />,},);